export const isLocalEnvironment = (location = window.location) =>
  location.hostname === "localhost";
